import React, { useState, useEffect } from "react";
import ReactExport from "react-data-export";
import Styles from './Styles';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Download = props => {
    const [ dataSet, setDataSet ] = useState([{
        columns:[],
        data:[]
    }]);

    useEffect(() => {
        formatData();
    },[props.data])

    if (props.loading) {
        return null
    };

    const formatData = () => {
        const labelStyle = Styles.shippingDetailLabelStyle

        const columns = [
            { title: "order_no", style:labelStyle},
            { title: "bulk_order_id", style:labelStyle},
            { title: "waybill_id", style:labelStyle},
            { title: "user_id", style:labelStyle},
            { title: "origin_name", style:labelStyle},
            { title: "origin_phone", style:labelStyle},
            { title: "origin_address", style:labelStyle},
            { title: "origin_email", style:labelStyle},
            { title: "origin_postal_code", style:labelStyle},
            { title: "origin_note", style:labelStyle},
            { title: "receiver_name", style:labelStyle},
            { title: "receiver_phone", style:labelStyle},
            { title: "receiver_address", style:labelStyle},
            { title: "receiver_email", style:labelStyle},
            { title: "receiver_postal_code", style:labelStyle},
            { title: "receiver_note", style:labelStyle},
            { title: "delivery_date", style:labelStyle},
            { title: "delivery_time", style:labelStyle},
            { title: "delivery_note", style:labelStyle},
            { title: "courier_company", style:labelStyle},
            { title: "courier_driver_name", style:labelStyle},
            { title: "courier_driver_phone", style:labelStyle},
            { title: "courier_service_type", style:labelStyle},
            { title: "shipment_fee", style:labelStyle},
            { title: "product_name", style:labelStyle},
            { title: "product_sku", style:labelStyle},
            { title: "product_length", style:labelStyle},
            { title: "product_width", style:labelStyle},
            { title: "product_height", style:labelStyle},
            { title: "product_quantity", style:labelStyle},
            { title: "product_value", style:labelStyle},
            { title: "order_note", style:labelStyle},
            { title: "status", style:labelStyle},
        ]

           
        let style = Styles.shippingDetailRowLightStyle;
        const data = props.data.reduce((r,i,idx) => {      
            style = style === Styles.shippingDetailRowLightStyle ? Styles.shippingDetailRowDarkStyle : Styles.shippingDetailRowLightStyle;

            r.push([
                {value: idx+1,style},
                {value: "",style},
                {value: i.waybillId,style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: i.courierPrice,style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: "",style},
                {value: 'delivered',style},
            ]);
           
            return r;
        },[])
        setDataSet([{
            columns,
            data
        }])
    }

    return (
        <div className={props.className}>
            <ExcelFile filename={props.filename} element={<button className={`btn btn-primary btn-block ${props.buttonClassName}`}>{props.title}</button>}>
                <ExcelSheet dataSet={dataSet} name="Upload Sheet"/>
            </ExcelFile>
        </div>
    );
}

export default Download;